export default __webpack_public_path__ + "static/media/keto_box@2x.efec14ea.jpg";